var _excluded = ["as", "classes", "stickyColumnContent", "mainContent"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
import TopLevelContainer from "../TopLevelContainer/index.js";
import Row from "../Row/index.js";
import Column from "../Column/index.js";
var MainContentColumn = function MainContentColumn(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes;
  var classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(Column, {
    className: classes['main-content-column']
  }, children);
};
process.env.NODE_ENV !== "production" ? MainContentColumn.propTypes = {
  children: PropTypes.node.isRequired,
  classes: classesPropType(['main-content-column'])
} : void 0;
var StickyLeftColumn = function StickyLeftColumn(_ref2) {
  var children = _ref2.children,
    classesProp = _ref2.classes;
  var classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(Column, {
    as: "aside",
    className: classes['sticky-left-column']
  }, children);
};
process.env.NODE_ENV !== "production" ? StickyLeftColumn.propTypes = {
  children: PropTypes.node.isRequired,
  classes: classesPropType(['sticky-left-column'])
} : void 0;
var ContainerWithStickyColumn = function ContainerWithStickyColumn(_ref3) {
  var ComponentToRender = _ref3.as,
    classes = _ref3.classes,
    stickyColumnContent = _ref3.stickyColumnContent,
    mainContent = _ref3.mainContent,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(TopLevelContainer, _extends({
    as: ComponentToRender,
    classes: classes
  }, rest), /*#__PURE__*/React.createElement(Row, {
    hGutters: false
  }, /*#__PURE__*/React.createElement(StickyLeftColumn, {
    classes: classes
  }, stickyColumnContent), /*#__PURE__*/React.createElement(MainContentColumn, {
    classes: classes
  }, mainContent)));
};
process.env.NODE_ENV !== "production" ? ContainerWithStickyColumn.propTypes = {
  /**
   * Component to render in place of the TopLevelContainer (e.g. "section")
   */
  as: PropTypes.elementType,
  /**
   * content for the sticky left-aligned column
   */
  stickyColumnContent: PropTypes.node.isRequired,
  /**
   * Class dependencies
   */
  classes: classesPropType(['main-content-column', 'sticky-left-column', 'top-level-container']),
  /**
   * content for the main content area to the right of the sticky column. If using a subgrid, should have a Row at the top.
   */
  mainContent: PropTypes.node.isRequired
} : void 0;
ContainerWithStickyColumn.defaultProps = {
  as: 'div'
};
export default ContainerWithStickyColumn;